module.exports = __webpack_public_path__ + "static/media/Untitled-1.ad50e28b.png";